/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig, contentOnly} from "./helper";

const urls = {
    boundary(id: number): string {
        return queryUrl("/land/boundary", {id});
    }
}

export default {
    urls,
    boundary(id: number): Promise<string> {
        return contentOnly(Axios.get(queryUrl("/land/boundary", {id}), defaultConfig));
    },
    boundaries(landIds: number[]): Promise<Record<number, string>> {
        return contentOnly(Axios.post("/land/boundaries", landIds, defaultConfig));
    }
}
